<template>
	<div>
		<section
			class="loader"
			:class="{
				'parent-game-dimen': id === 'parentgame',
				'cvs-dimen': id === 'cvs',
				'streaks-dimen': id === 'streak',
				'jobmatch-dimen': id === 'jobmatch' || id === 'interviewGraph',
				'resume-clinic-height': id == 'resumeclinic',
				'resume-modal-height': id == 'resumemodal',
				'loader-modal': id == 'modal',
				'no-margin': id == 'nomargin',
			}"
		>
			<div
				:class="['first-circle', { animate: firstCircleAnimate }]"
				:style="{ background: firstCircleBackground }"
			></div>
			<div
				:class="['firstmid-circle', { animate: firstMidCircleAnimate }]"
			></div>

			<div
				class="position-relative"
				:class="['second-circle', { animate: secondRectangleAnimate }]"
				:style="{ background: secondBgColor }"
			>
				<div class="white-line"></div>
				<div class="white-round"></div>
			</div>
		</section>
		<div v-if="id == 'resumeclinic' || id == 'modal'" class="rescli-haze-txt">
			<transition name="slide-left">
				<span :key="currentPhrase" class="phrase">{{
					loaderText[currentIndex]
				}}</span>
			</transition>
		</div>
		<div v-if="id == 'loaderPage'" class="rescli-haze-txt">
			<span class="phrase"> Loading Details ... </span>
		</div>
	</div>
</template>

<script>
export default {
	name: "SpinnerComponent",
	props: {
		id: { type: String, default: "" },
		loaderText: {
			type: Array,
			default: () => [
				"Parsing your resume",
				"Analysing your experience",
				"Extracting your skills",
				"Generating Recommendations",
			],
		},
	},
	data() {
		return {
			firstCircleAnimate: false,
			firstMidCircleAnimate: false,
			midContentAnimate: false,
			secondRectangleAnimate: false,
			firstCircleBackground: "#f0f6ff",
			secondBgColor: "f0f6ff",
			timeouts: [],
			intervals: null,
			currentIndex: 0,
		};
	},
	mounted() {
		document.addEventListener("visibilitychange", () => {
			if (document.hidden) {
				this.timeouts.forEach((timeout) => {
					clearTimeout(timeout);
				});
				clearInterval(this.intervals);
			} else {
				this.restartAnimationCycle();
				this.intervals = setInterval(() => {
					this.restartAnimationCycle();
				}, 1500);
			}
		});

		this.restartAnimationCycle();
		this.intervals = setInterval(() => {
			this.restartAnimationCycle();
		}, 1500);
		if (this.id == "resumeclinic" || this.id == "modal") {
			this.startAnimation();
		}
	},
	computed: {
		currentPhrase() {
			return this.loaderText[this.currentIndex];
		},
	},
	methods: {
		async triggerAnimationCycle() {
			this.timeouts.push(
				setTimeout(() => {
					this.firstCircleAnimate = true;
					this.firstCircleBackground = "#f0f6ff";
				}, 300)
			);
			this.timeouts.push(
				setTimeout(() => {
					this.firstCircleBackground = "unset";
					this.firstMidCircleAnimate = true;
				}, 700)
			);
			this.timeouts.push(
				setTimeout(() => {
					this.firstCircleBackground = "unset";
					this.secondRectangleAnimate = true;
					this.secondBgColor = "#f0f6ff";
				}, 1100)
			);
			this.firstCircleBackground = "#f0f6ff";
		},
		async restartAnimationCycle() {
			this.timeouts = [];
			this.firstCircleAnimate = false;
			this.firstMidCircleAnimate = false;
			this.secondRectangleAnimate = false;

			this.triggerAnimationCycle();
		},
		startAnimation() {
			setInterval(() => {
				this.currentIndex = (this.currentIndex + 1) % this.loaderText.length;
			}, 1500);
		},
	},
};
</script>

<style scoped>
.loader {
	width: 100vw;
	height: 100vh;
	display: flex;
	align-items: center;
	justify-content: center;
	margin-left: -80px;
}

.first-circle {
	width: 45px;
	height: 45px;
	position: relative;
	border-top-left-radius: 50px;
	border-bottom-left-radius: 50px;
	transform: rotate(49deg);
	z-index: 1000;
	background: #f0f6ff;
	overflow: hidden;
}

.first-circle::before {
	position: absolute;
	content: "";
	bottom: 0px;
	left: 0px;
	width: 0;
	height: 100%;
	background-color: #68a5ff;
	transition: width 0.4s linear;
	z-index: -1;
}

.first-circle.animate::before {
	width: 100%;
	animation: growWidth 0.4s linear forwards;
}

@keyframes growWidth {
	from {
		width: 0%;
	}
	to {
		width: 100%;
	}
}
.firstmid-circle {
	height: 16px;
	width: 18px;
	border-bottom-right-radius: 100%;
	border-top-right-radius: 0px;
	z-index: 500;
	transform: rotate(48deg);
	margin-top: 27px;
	background: #f0f6ff;
	overflow: hidden;
}

.firstmid-circle::before {
	position: absolute;
	content: "";
	bottom: 0px;
	left: 0px;
	width: 0;
	height: 100%;
	background-color: #68a5ff;
	transition: width 0.2s linear;
	z-index: -1;
}

.firstmid-circle.animate::before {
	width: 100%;
	animation: growMidWidth 0.2s linear forwards;
}

@keyframes growMidWidth {
	from {
		width: 0%;
	}
	to {
		width: 100%;
	}
}

.second-circle {
	width: 41px;
	height: 180px;
	transform: rotate(49deg);
	margin-left: 18px;
	border-top-left-radius: 50px;
	border-top-right-radius: 50px;
	border-bottom-right-radius: 80px;
	position: relative;
	margin-top: -27px;
	background: #ebedf0;
	overflow: hidden;
}

.second-circle::before {
	position: absolute;
	content: "";
	bottom: 0px;
	left: 0px;
	width: 100%;
	height: 0;
	background-color: #344966;
	transition: height 0.3s linear;
	z-index: -1;
	border-top-left-radius: 50px;
	border-top-right-radius: 50px;
	border-bottom-right-radius: 80px; /* Start radius */
	overflow: hidden;
}

.second-circle.animate::before {
	/* height: 100%; */
	animation: growsecondWidth 0.3s linear forwards;
}

@keyframes growsecondWidth {
	from {
		height: 0%;
		border-bottom-right-radius: 80px;
	}
	to {
		height: 100%;
		border-bottom-right-radius: 88px;
	}
}

.white-round {
	position: absolute;
	bottom: 26px;
	left: 0px;
	height: 21px;
	width: 21px;
	border-radius: 0px 246px 0 0;
	background-color: #fff;
	transform: rotate(89deg);
}

.white-line {
	position: absolute;
	bottom: 0px;
	height: 33px;
	width: 4px;
	background: #fff;
}
.parent-game-dimen {
	height: 100%;
	width: 100%;
	margin-left: 0;
}
.cvs-dimen {
	height: calc(100vh - 211px);
	backdrop-filter: blur(5px);
	width: 100%;
	margin-left: 0;
	position: absolute;
}
.streaks-dimen {
	height: 100%;
	width: 100%;
	margin-left: 0;
}
.jobmatch-dimen {
	margin-left: 0;
	height: 100%;
	width: 100%;
}
.loader-modal {
	margin-left: 0;
	height: 500px;
	width: 100%;
}
.streaks-dimen .first-circle {
	width: 35px !important;
	height: 35px !important;
}
.streaks-dimen .firstmid-circle {
	height: 10px !important;
	width: 12px !important;
	margin-top: 16px !important;
}

.streaks-dimen .second-circle {
	width: 31px !important;
	height: 150px !important;
}
.streaks-dimen .white-round {
	position: absolute;
	bottom: 22px;
	left: 0px;
	height: 18px;
	width: 10px;
}

@media (max-width: 1028px) {
	.parent-game-dimen {
		height: 75%;
	}
	.resume-modal-height {
		height: 100vh !important;
		width: 100%;
		justify-content: center;
		padding-right: 57px;
	}
}

.phrase {
	display: inline-block;
	white-space: nowrap;
	position: absolute;
}

.slide-left-enter-active,
.slide-left-leave-active {
	transition: transform 0.6s ease, opacity 0.6s ease;
}

.slide-left-enter {
	transform: translateX(100%);
	opacity: 0;
}

.slide-left-leave-to {
	transform: translateX(-100%);
	opacity: 0;
}
.resume-clinic-height {
	height: calc(100vh - 195px);
	position: relative;
}

.rescli-haze-txt {
	position: absolute;
	left: 32px;
	display: flex;
	justify-content: center;
	width: 97%;
	bottom: 40%;
	z-index: 7;
	font-family: "Inter", sans-serif;
	font-size: 20px;
	font-weight: 500;
	color: #263238;
}
.no-margin {
	margin-left: -22px;
}
.resume-modal-height {
	height: calc(100vh - 220px);
	width: 100%;
	margin-left: 0;
}
.analyze-exp {
	left: calc((100% - 250px) / 2) !important;
}
.generate-recom {
	left: calc((100% - 270px) / 2) !important;
}
</style>
